<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img" :style="{ 'background': `url(${prodThree1.image}) 0 0 no-repeat`, backgroundSize: '100%' }">
      <div class="img_tit">{{ prodThree1.title }}</div>
      <div class="img_desc">
        {{ prodThree1.subtitle }}
      </div>
    </div>
    <div class="current_show_menu">
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center" style="width: 60%">
            <div class="enter_title">{{ prodThree2.title }}</div>
            <div class="enter_desc hidden-xs-only">
              {{ prodThree2.subtitle }}
            </div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <Row class-name="enter_card_wrap hidden-xs-only" :gutter="20" justify="center">
        <Col span="6" v-for="item in prodThree2Children">
        <Card :bordered="true" class="enter_card_item">
          <p slot="title" class="title">{{ item.title }}</p>
          <br />
          <br />
          <br />
          <p>{{ item.subTitle }}</p>
          <br />
          <br />
          <br />
        </Card>
        </Col>
      </Row>
      <div class="enter_card_wrap_mobile hidden-sm-and-up">
        <img src="@/assets/img/16f7580f76.png" alt="" />
      </div>
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="enter_title">{{ prodThree3.title }}</div>
            <div class="enter_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img :src="prodThree3.image" alt="" />
        </div>
        <div class="mall_details">
          <p>
            {{ prodThree3.subtitle }}
          </p>
          <div class="mall_btn">
            <!-- <el-button class="btn_self" @click="gotoDemo">了解更多</el-button> -->
          </div>
        </div>
      </div>
      <div class="func_wrap" :style="{ 'background': `url(${prodThree4.image})` }">
        <div class="func_wrap_inner">
          <div class="func_tit">{{ prodThree4.title }}</div>
          <el-row class="func_card hidden-xs-only" type="flex">
            <el-col class="card_item" v-for="(item, index) in funcCardList" :key="index" :span="5">
              <div class="item_top" :style="{ 'background': `url(${item.bg})` }">
                <p>{{ item.tit }}</p>
              </div>
              <div class="item_bottom">
                <p v-for="(item2, index2) in item.desc" :key="index2">
                  {{ '○ ' + item2 }}
                </p>
              </div>
            </el-col>
          </el-row>
          <div class="func_card_mobile hidden-sm-and-up">
            <img src="@/assets/img/3572170410.png" alt="" />
          </div>
          <div class="func_card_mobile hidden-sm-and-up">
            <img src="@/assets/img/3572170410.png" alt="" />
          </div>
          <div class="func_card_mobile hidden-sm-and-up">
            <img src="@/assets/img/3572170410.png" alt="" />
          </div>
        </div>
      </div>
      <div class="func_wrap" style="background: #f4f9fc">
        <div class="func_wrap_inner">
          <div class="func_tit">{{ prodThree5.title }}</div>
        </div>
        <div class="double_card_wrap">
          <el-row class="double_card" type="flex">
            <el-col :span="5" :xs="11" class="double_card_item"
              :style="{ 'background': `url(${item.image}) 100% 100% no-repeat`, backgroundSize: '30%', backgroundColor: 'white' }"
              v-for="item in this.prodThree5Children">
              <div class="double_card_bg"></div>
              <p>{{ item.title }}</p>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import { findMainProp, transDictDataNotTypeMore, transDictDataTotal } from '../../utils';
import { leftLikeDict } from '../../api/system';
import Constant from '../../utils/Constant';
export default {
  data() {
    return {
      prodThree1: {},
      prodThree2: {},
      prodThree3: {},
      prodThree4: {},
      prodThree5: {},
      prodThree5Children: {},
      prodThree2Children: [],
      prodThree4Children: {},
      selectName: '1',
      funcCardList: [
      ],
    }
  },
  methods: {
    selectMenuItem(name) {
      console.log(name)
    },
    gotoDemo() {
      // this.$router.push('/demo')
    },
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.PROD_THREE1);
      if (res.data) {
        this.prodThree1 = findMainProp(res.data.data, Constant.PROD_THREE1)
      }
      const res2 = await leftLikeDict(Constant.PROD_THREE2);
      if (res2.data) {
        this.prodThree2 = findMainProp(res2.data.data, Constant.PROD_THREE2)
        this.prodThree2Children = transDictDataNotTypeMore(res2.data.data.find(v => v.dictKey === 'prod_three2Title')?.children, 'prod_three2Content')
      }
      const res3 = await leftLikeDict(Constant.PROD_THREE3);
      if (res3.data) {
        this.prodThree3 = findMainProp(res3.data.data, Constant.PROD_THREE3)
      }
      const res4 = await leftLikeDict(Constant.PROD_THREE4);
      if (res4.data) {
        this.prodThree4 = findMainProp(res4.data.data, Constant.PROD_THREE4)
        this.prodThree4Children = transDictDataTotal(res4.data.data.find(v => v.dictKey === 'prod_three4Title')?.children, 'prod_three4Content')
        this.funcCardList = this.prodThree4Children.reduce((pre, cur, i) => {
          pre.push({
            tit: cur.Title,
            desc: cur.SubTitle,
            bg: require(`../../assets/img/bg1.png`)
          })
          return pre
        }, [])
      }
      const res5 = await leftLikeDict(Constant.PROD_THREE5);
      if (res5.data) {
        this.prodThree5 = findMainProp(res5.data.data, Constant.PROD_THREE5)
        this.prodThree5Children = transDictDataNotTypeMore(res5.data.data.find(v => v.dictKey === 'prod_three5Title')?.children, 'prod_three5Content')
        console.log(this.prodThree5Children);

      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  },
  components: {
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;

  .enter_img {
    width: 100%;
    height: 600px;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .enter_menu_wrap {
    @media screen and (max-width: 768px) {
      height: 40px;
    }

    .enter_menu_item {
      width: 50%;
      text-align: center;
      font-size: 22px;

      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .enter_title_wrap {
    width: 100%;
    margin-top: 50px;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .enter_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;

        @media screen and (max-width: 768px) {
          flex: 2.2;
        }

        .enter_title {
          font-size: 40px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .enter_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;

          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .current_show_menu {
    .enter_card_wrap_mobile {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .enter_card_wrap {
      width: 100%;
      margin-top: 50px;

      .enter_card_item {
        background: #f4f9fc;
        text-align: center;

        p {
          width: 60%;
          text-align: center;
          margin: 0 auto;
          font-size: 16px;
        }

        .title {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }

    .mall_wrap {
      width: 70%;
      display: flex;
      justify-content: center;
      margin: 34px auto;

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      @media screen and (max-width: 768px) {
        flex-direction: column;
      }

      .mall_img {
        width: 50%;
        margin-right: 30px;
        padding: 0 30px;

        @media screen and (max-width: 768px) {
          width: 100%;
        }

        img {
          width: 100%;
        }
      }
    }

    .mall_details {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media screen and (max-width: 768px) {
        width: 90%;
        text-align: center;
      }

      p {
        font-size: 20px;

        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }

      .mall_btn {
        margin-top: 40px;

        @media screen and (max-width: 768px) {
          padding: 20px 0;
        }

        .btn_self {
          background: orange;
          color: #fff;
          border-radius: 20px;
          border: none;

          @media screen and (max-width: 768px) {
            width: 80px;
            height: 35px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }

  .func_wrap {
    width: 100%;
    padding: 50px;
    background-size: 100% 100%;

    .func_wrap_inner {
      width: 70%;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .func_tit {
        font-size: 34px;
        font-weight: bold;
        text-align: center;

        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }

      .func_card {
        justify-content: space-between;
        margin-top: 40px;

        .card_item {
          background: #fff;
          box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.1);

          .item_top {
            width: 100%;
            height: 150px;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .item_bottom {
            padding: 15px;

            p {
              font-size: 16px;
              margin-top: 20px;
            }
          }
        }
      }

      .func_card_mobile {
        width: 100%;

        img {
          width: 100%;
          margin-top: 40px;
        }
      }
    }

    .double_card_wrap {
      width: 70%;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .double_card {
        justify-content: space-between;
        margin-top: 50px;

        @media screen and (max-width: 768px) {
          flex-wrap: wrap;
        }

        .double_card_item {
          height: 250px;
          background: rgba($color: #fff, $alpha: 1);
          padding: 30px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;

          background-position: 100% 100%;
          background-repeat: no-repeat;
          background-size: 30%;

          @media screen and (max-width: 768px) {
            height: 140px;

            &:nth-child(n+3) {
              margin-top: 20px;
            }
          }

          .double_card_bg {
            width: 30px;
            height: 15px;
            background: linear-gradient(90deg, rgba(252, 197, 96, 0), #feb15a);

            @media screen and (max-width: 768px) {
              width: 20px;
              height: 8px;
            }
          }

          p {
            line-height: 20PX;
            font-size: 15px;
            margin-top: 30px;

            @media screen and (max-width: 768px) {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}
</style>